import React from 'react';
import './Header.css';

export default function Header() {
	return (
		<header className='Header'>
			<h1>STAR WARS SEARCHER</h1>
		</header>
	)
}